import { useEffect }  from 'react'
import { store }      from 'index';
import { 
    getPlusRequest, 
    getGradeRequest 
}                     from 'utils/constants';
 
  const useSetFormInput = (
    setMessage: (val: string) => void,
    setName:    (val: string) => void,
    setEmail:   (val: string) => void,
  ) => {

    const state      = store.getState();
    const modalState = state.modal;
    const userInfo   = state.data.userInfo;

    useEffect(() => {
  
      const { userName, userEmail } = userInfo;

       if ( modalState.modalVariant === 'getPlus' ) {
          setMessage(getPlusRequest)
       }
       if ( modalState.modalVariant === 'getGrade' ) {
          setMessage(getGradeRequest)
       }
  
       if ( !!userName.length && userName !== 'guest' ) {
          setName(userName);
       }
       if ( !!userEmail.length && userEmail !== 'guest@yisumatica.org.il' && userEmail.includes('@') && modalState.modalVariant !== 'whatsappRegistration' ) {
          setEmail(userEmail);
       }
       if (modalState.modalVariant === 'whatsappRegistration') {
          setEmail('');
       }
  
    },[userInfo, modalState, setMessage, setName, setEmail])
  
}
  
  
  export default useSetFormInput;
  